/**
 * Automated Alt Text Correction for The Hills Pub
 * Satisfies WCAG 2.1.1 (Non-text Content)
 */
(function() {
  function applyAltText() {
    // 1. Fix Footer Logo
    const footerLogos = document.querySelectorAll('.footer-block__details-content img, img[src*="thehillspub_l"]');
    footerLogos.forEach(img => {
      if (!img.getAttribute('alt') || img.getAttribute('alt').trim() === "") {
        img.setAttribute('alt', 'The Hills Pub Logo');
      }
    });

    // 2. Fix Hero/Circle Images (targets the specific hero classes from the report)
    const heroImages = document.querySelectorAll('.hero-circle-image-circle_BPtbUd img, .hero-circle-image-circle_kP9cdz img');
    heroImages.forEach(img => {
      if (!img.getAttribute('alt') || img.getAttribute('alt').trim() === "") {
        // These appear to be informative brand banners/circles
        img.setAttribute('alt', 'The Hills Pub Featured Brand Image');
      }
    });

    // 3. General cleanup for any other informative icons that might be missing alt text
    // (Optional: add more specific selectors here if you find more issues)
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAltText);
  } else {
    applyAltText();
  }

  // Watch for dynamic content (Shopify sections often load via AJAX)
  const observer = new MutationObserver((mutations) => {
    applyAltText();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
